import { isMobile } from "react-device-detect"

export const deviceMargin = isMobile ? 1 : 5
export const LOGIN_INTERVAL = 120000 // Time between each access log verification